var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.items,"size":"mini","height":"320"}},[_c('el-table-column',{attrs:{"prop":"address","label":"Address"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n      "+_vm._s(_vm._f("splitAddressByHyphen")(scope.row.address))+"\n    ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"publicKey","label":"PublicKey"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d1ced734","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SignatoryCollection.vue
// module id = null
// module chunks = 